import { Component, inject, Input } from '@angular/core';
import { MiniEnvInfoCardComponent } from "../../ui/cardbox/mini-env-info-card/mini-env-info-card.component";
import { SharedDataService } from '@src/app/core/services/shared-data.service';
import { COMMON_MODULES } from '@src/app/core/constants/common-module.constant';

@Component({
  selector: 'app-mini-env-benefit-cards',
  imports: [...COMMON_MODULES, MiniEnvInfoCardComponent],
  templateUrl: './mini-env-benefit-cards.component.html',
  styleUrl: './mini-env-benefit-cards.component.scss'
})
export class MiniEnvBenefitCardsComponent {
sharedService = inject(SharedDataService);
@Input() services: any;


}
